import React from "react";
import Layout from "../Layout";
import { useTranslation } from "react-i18next";
import { FaWhatsapp, FaFacebook, FaTwitter, FaInstagram } from "react-icons/fa";
import { MdOutlineEmail } from "react-icons/md";
import { LuPhone } from "react-icons/lu";
import FormContactUs from "./FormContactUs";

function ContactUs() {
  const { t } = useTranslation();
  return (
    <Layout title={t("pages.contact")}>
      <section className="py-16 px-6 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Left: Form */}
          <div className="border rounded-xl shadow-md p-8">
            <h3 className="text-2xl font-bold mb-2">
              {t("contact.sendMessage")}
            </h3>
            <p className=" mb-6">{t("contact.sendMassageParagraph")}</p>
            <FormContactUs />
          </div>

          {/* Right: Contact Info */}
          <div className=" border rounded-xl shadow-md p-8 flex flex-col justify-between">
            <div>
              <h3 className="text-2xl font-bold mb-4">
                {t("contact.ReachOutDirectly")}
              </h3>
              <ul className="space-y-4 text-gray-700">
                <li>
                  <a
                    className="flex cursor-pointer items-center gap-3"
                    href="tel:+971528350086"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <LuPhone className="text-blue-500 text-xl" />
                    <span dir="ltr">+971 52 835 0086</span>
                  </a>
                </li>
                <li>
                  <a
                    className="flex cursor-pointer items-center gap-3"
                    href="mailto:info@twhmenu.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <MdOutlineEmail className="text-blue-500 text-xl" />
                    <span>info@twhmenu.com</span>
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex cursor-pointer items-center gap-3"
                    href="https://wa.me///+971528350086?text=Hello%21+I+found+TWHMENU.com+and+I+want+to+create+digital+menu"
                  >
                    <FaWhatsapp className="text-green-500 text-xl" />
                    <span dir="ltr">+971 52 835 0086</span>
                  </a>
                </li>
              </ul>
            </div>

            {/* Social Media */}
            <div className="mt-8 border-t pt-6">
              <h3 className="text-lg font-semibold mb-3">
                {t("contact.ConnectWithUs")}
              </h3>
              <div className="flex gap-4 text-2xl text-gray-600">
                <a
                  href="https://www.facebook.com/share/1FQEcag2w5/"
                  className="hover:text-blue-600"
                >
                  <FaFacebook />
                </a>

                <a
                  href="https://www.instagram.com/twh.tech?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                  className="hover:text-pink-500"
                >
                  <FaInstagram />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default ContactUs;
